import {RequestInvitationsApp} from "../Functionality/RequestInvitationsApp";
import React from "react";
import RequestInvitationHeader from "./RequestInvitationHeader";
import CustomExpandableTable from "../../../../../components/table/CustomExpandableTable";
import RenderExpandedRow from "./RenderExpandedRow";
import NotInformation from "../../../../../components/NotInformation";
import {INVITATION_VIEW_TYPE} from "../../Invitation/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const RequestInvitations = (props) => {
    const {
        selectedList,
        setSelectedList,
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        setBodyForExport,
        finalArray,
        setFinalArray,
        search,
        setSearch,
        setCriteria,
        modified,
        setModified
    } = props;

    const {
        columns,
        handleRowExpand,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        results,
        DEV,
        permission,
        setResults,
        option,
        page,
        rowsPerPage,
        userId,
        RenderOptionsMenu,
        searchId,
        setSimpleSearch,
        t
    } = RequestInvitationsApp({
        selectedList,
        setSelectedList,
        searchElement,
        finalArray,
        setCriteria,
        setBodyForExport,
        modified,
        setModified
    });

    return (
        <>
            <RequestInvitationHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                finalArray={finalArray}
                setFinalArray={setFinalArray}
                DEV={DEV}
                permission={permission}
                userId={userId}
                viewType={INVITATION_VIEW_TYPE.REQUESTED_INVITATIONS}
            />


            {results?.content?.length > 0 ? (
                <div className={"mt-3"}>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={results?.content}
                        renderExpandedRow={RenderExpandedRow}
                        renderOptionsMenu={RenderOptionsMenu}
                        checkbox={false}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
              </div>
                ) : (
                    <NotInformation
                        className={"mt-4"}
                        text={t('no_information')}
                        card={true}
                    />
            )}
        </>
    );
};

export default RequestInvitations
